import { ProfilePageLayout } from '@modules/_shared/components/ProfilePageLayout';
import { useLocale } from '@shared/hooks/locale';

export const TakedownAgent = () => {
  const { t } = useLocale();
  return (
    <ProfilePageLayout
      intent="takedown"
      target="agent"
      title={t('Want to remove your profile?')}
      ctaLabel={t('Claim my profile instead')}
      description={t(
        'Before you go: homeowners already see you on RealAdvisor. Claim your profile for free instead and decide what they see.',
      )}
    />
  );
};
